export default __webpack_public_path__ + "static/media/network-graph-0-lqMAX.b73a9c2e.jpg";